import fpApiUtil from "./fp-api-util";

const ANALYSIS = "factoryplan/analysis";

// 작업 교체 시간 정보(공장>스테이지>자원별 작업교체 시간(분)/횟수 크로스탭) — AnalysisController
// #getJobChangTimeInfo(백엔드는 factoryplan/analysis/job-change-time). 다른 크로스탭 화면과 같은
// { crosstabHeader, chartHeader, data[].pivotData } 형태, measure(analysisIndicator: FP_TIME_MINUTES/
// TIMES 2종 고정)가 leaf 필드. old도 그리드 조회(loadData)/차트 드릴다운(loadChartData) 둘 다 같은
// 엔드포인트를 resourceCdNm 필터값만 다르게 호출한다. 이 화면은 시간 버킷을 지원하지 않는다
// (JobChangeTimeInfoService#getJcTimeInfo가 isHourBucket()이면 빈 결과 반환).
const getJobChangeTimeInfos = (params) => fpApiUtil.postParams(`${ANALYSIS}/job-change-time`, params);

// 같은 엔드포인트의 차트용 호출 — 그리드에서 클릭한 행(plantCd/stageCd/resourceCd)으로 드릴다운,
// useGrouping:true로 그 레벨까지 백엔드가 집계해서 내려준다(JcTimeInfoCrosstabDto.merge,
// GroupingLevel 참고, ResourceUtilization과 동일 계열). 컬럼 필터(changes)는 1차 미이관이라 항상
// 빈 객체로 보낸다(fp-report-screen-guide.md §A-6e와 동일 결정).
const getJobChangeTimeInfoChart = (params, changes) =>
  fpApiUtil.postFields(`${ANALYSIS}/job-change-time`, { params, changes });

const fpJobChangeTimeInfoService = { getJobChangeTimeInfos, getJobChangeTimeInfoChart };
export default fpJobChangeTimeInfoService;
